import Api from '@/services/Index'

const sendSms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/start', data)
}

const verifySms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/verify', data)
}

const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/login', data)
}

const updatePersonalInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-personal-information', data)
}

const updateEducationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-education-information', data)
}

const updateApplicationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-application-information', data)
}

const passwordReminder = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/password-reminder', formData)
}

const downloadFileApplicationSide = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/download-document', formData, {responseType: 'arraybuffer'})
}

/// Admin
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications', config)
}

const update = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/applications/'+id, formData)
}

const downloadFile = async (applicationId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications/download-file/'+applicationId, {responseType: 'arraybuffer'})
}

const bulkMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/applications/bulk-message', formData)
}

const sendMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/messages', formData)
}

const updateMessage = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/application/messages/'+id, formData)
}

const deleteMessage = async (messageId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/fashion/design/application/messages/'+messageId)
}


export default {
    sendSms,
    verifySms,
    login,
    updatePersonalInfo,
    updateEducationInfo,
    updateApplicationInfo,
    getAll,
    passwordReminder,
    update,
    downloadFile,
    downloadFileApplicationSide,
    bulkMessage,
    sendMessage,
    updateMessage,
    deleteMessage

}
